import React, { useState, useEffect, useRef } from 'react'
import { useOidc, withOidcSecure } from '@axa-fr/react-oidc'
import { width } from "../../CustomComponents/Card/CardStyles";
import { useTranslation } from 'react-i18next';
import HomeLayout from '../../Layout/HomeLayout';
import DynamicCard from '../../CustomComponents/DynamicHomeCard';
import { useNavigate } from 'react-router';
import FooterContent from '../../CustomComponents/Footer';
import { clearStorageExceptKey, SecuritySidebar } from '../../../utils';
import { useSelector, useDispatch } from 'react-redux';
import { appTheme, capitalizeFirstLetter, fetchConfigarationData, retrieveData } from '../../../helpers/utils/Utils';
import Loader from '../../CustomComponents/Loader';
import { CONTACT_US_URL, END_SESSION, ENROLL_STATUS_APP, ENROLL_STATUS_PEN, GENERATE_OTP_CHANGE_PASSWORD, IDOLOGY_ACCOUNT_STATUS_CHECK, IDOLOGY_VALIDATE_QUESTIONS, IDOLOGY_VALIDATE_QUESTIONS_SMIONE, INITIAL_DELAY, MAX_ATTEMPTS, POLLING_INTERVAL, STATUS_SUCCESS_CODE } from '../../../network/URLConstants';
import logFirebaseEvents from '../../LogFirebaseEvents';
import Radio from '../../../assets/kudzu-plus-images/securityQuestionRadio.png'
import About from '../../OnBoard/About';
import RadialFill from '../../../assets/images/Radial Fill.png'
import RadialNull from '../../../assets/images/Radial Null.png'
import IdologyLayout from '../../Layout/IdologyLayout';
import rightArrow from '../../../assets/images/right-arrow-enable.png';
import Oops from '../../../assets/images/Oops.png';

import CustomAlertModel from '../../CustomComponents/CustomAlertModel';
import { GetApiHeadersWithBearer, GetApiHeadersWithOutBearer, GetRequest, PostRequest } from '../../../network/NetworkUtils';
import { store } from '../../../Redux/store';
const appConfigData = await fetchConfigarationData();
var finalObj={} 
var isChallenge=false

const SecurityQuestion = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const idoloyResponseData = useSelector(state => state.idoloyResponse);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [selectedType, setSelectedType] = useState('');;
    const cards = useSelector(state => JSON.parse(state.userCards));
    const [isLoading, setIsLoading] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState({});
    // const HighlightMsgStyles = "font-serif-pro mr-[12px] modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[#94C3E8] cursor-pointer pointer-events-none";
    // const HeaderMsgStyles = "font-serif-pro modal-title text-[#FFFFFF] lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none w-[90%] md:w-[80%]";
    // const SubHeaderMsgStyles = "font-hanken-grotesk modal-title text-[#FFFFFF] lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
    const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-text-highlight)] ";
    const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-text-heading-clr)]";
    const SubHeaderMsgStyles = "font-hanken-grotesk modal-title lg:w-[445px] lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal text-[var(--modal-text-heading-clr)]";
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn3Exists, setbtn3Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [btn3Text, setBtn3Text] = useState('')
    const [modelImage, setModelImage] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [footerMsg, setFooterMsg] = useState('');
    const [subFooter, setSubFooter] = useState('');
    const [btn1Focus, setBtn1Focus] = useState(false);
    const [btn2Focus, setBtn2Focus] = useState(false);
    const [showErrorImg, setshowErrorImg] = useState(false);
    const [isBorderNone, setisBorderNone] = useState(true);
    const [showModel, setShowModel] = useState(false);
    const [skipQuestionCount, setSkipQuestionCount] = useState(0);
    const [localErrorMessage, setLocalErrorMessage] = useState('');
    const [buttonDisable, setButtonDisable] = useState(false);
    const [nextBtnDisable, setNextBtnDisable] = useState(false);
    const [skipButtonHide, setSkipButtonHide] = useState(false);
    const [trackedUrl, setTrackedUrl] = useState('');
    const [errorCount, setErrorCount] = useState(0);
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const userId = useSelector(state => state.userId);
    const { login, logout, isAuthenticated, renewTokens, oidcUser } = useOidc();
    const iframeRef = useRef(null);
    const accessTokenToApi = useSelector(state => state.accessToken);
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 
    const signUpkudzuPlusTrue = useSelector(state => state.isSignUpKudzuplusTrue);
    const appThemeData = appTheme(kudzuPlusTrue  ? kudzuPlusTrue :  signUpkudzuPlusTrue )
    const isFromSmiOne = useSelector((state) => state.fromSmiOne);
    

    const iframeUrl = "https://web.idologylive.com/idscan/v2.jsp?id=dwijL5Yj30308af7c3"

    const [selectedAnswers, setSelectedAnswers] = useState({
        id_number: idoloyResponseData?.id_number || "",
    });

    const questionsData = idoloyResponseData?.questions || [];
    const skipLimit = idoloyResponseData?.skip_questions_count || '';
    const skipQuestionMessage = idoloyResponseData?.skip_question_message || '';
    const scanUrl = idoloyResponseData?.scan_url || '';
    // const scanUrl = "https://web.idologylive.com/idscan/v2.jsp?id=dwijL5Yj30308af7c3"  
    
    
    const handleNextQuestion = () => {
        debugger;
        const dataLength = questionsData.length - 1
        setLocalErrorMessage("");
        if(currentQuestionIndex == dataLength - 1 && skipQuestionCount == 0 && !isChallenge ){
            handleSelectOption("", dataLength, true);
        }
        else  if (currentQuestionIndex < dataLength) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        } else {
            validateQuestionsApi(selectedAnswers)
        }
    };
    

    const validateQuestionsApi = async (finalObject) =>{
        setIsLoading(true) 
        const deviceId = await retrieveData('updatedDeviceId');
            if(userId){
                var headers = await GetApiHeadersWithOutBearer(deviceId);
                }
            else{
            var headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);  
            }
         if(idoloyResponseData.isChallenge){
            var object=  {
                isChallenge:true,
                ...finalObject,
            }
            if(userId){
                object.appId = appConfigData.CLIENT_ID
            }
            
        }
        else{
            
            var object =  {
                ...finalObject,
            }
            if(userId){
                object.appId = appConfigData.CLIENT_ID
            }
        }

        // var url = IDOLOGY_VALIDATE_QUESTIONS('1b8d68bc-9b7b-4b24-89f8-371b7e51f3d4')
        if(isFromSmiOne){
        var url = IDOLOGY_VALIDATE_QUESTIONS_SMIONE(userId)

        }else{
        var url = IDOLOGY_VALIDATE_QUESTIONS(userId)
        }
        var response = await PostRequest(url, object, headers)

        let parsedResponse = JSON.parse(response);
        if (parsedResponse.ResponseCode == STATUS_SUCCESS_CODE) {
            setIsLoading(false)
            if(!parsedResponse.Response.success && parsedResponse.Response.isChallenge ){
                isChallenge = true
                setCurrentQuestionIndex(0)
                setSelectedOptions({})
                setButtonDisable(true)
                const idoloyResponsePayload = { idoloyResponse: parsedResponse.Response}
                dispatch({ type: 'IDOLOGY_RESPONSE', payload: idoloyResponsePayload });
                showAlertModal(true, t("oops_exclamation_coma"), t("we_were_not_able-to-verify_your_identity"), t('Please_answer_these_additional_questions_to'), false, false, '', '', false,signUpkudzuPlusTrue ? require('../../../assets/kudzu-plus-images/reports-dark.png') : require('../../../assets/images/illo-report.png') , '', false, false, true, false,true,t('continue'))
            }
            else if (!parsedResponse.Response.success){
                showAlertModal(true,t("thanks"),t("Idology_application_is_under_review"),t("Idology_verifying_your_documentation_and_will"),false,false,t("login"),"",false,signUpkudzuPlusTrue ? require("../../../assets/kudzu-plus-images/illo-pending-dark.png") : require("../../../assets/images/illo-pending.png"),
                    <span className='text-[var(--modal-text-heading-clr)] '>
                        {t("For_further_assistance")}&nbsp;
                        <span onClick={() => { window.open(CONTACT_US_URL, "_blank"); }} className='text-[var(--modal-text-highlight)] font-bold cursor-pointer'>{t("Customer_Care")}</span>&nbsp;
                    </span>,false,false,true,false,false,""); 
            }
            else{
                showAlertModal(true, t("success"), t("Idology_Your_Kudzu_account_has_been_created"), t('Idology_Your_Kudzu_account_is_approved'), true, false, t('login'), '', true,signUpkudzuPlusTrue ? require('../../../assets/kudzu-plus-images/illo-complete-dark.png') : require('../../../assets/images/illo-complete-success.png'), '', false, false, true, false,false,'')
            }
        } else {
            setIsLoading(false)
            var arrMessages = parsedResponse.Messages;
            var message = arrMessages[0];
            var displayText = message.DisplayText;
            showAlertModal(true, t("kudzu"), '', displayText, true, false, t("login"), '', true, require('../../../assets/images/warning.png'), false, false)
        }
    }



    const handleSelectOption = (option, index, callApi) => {
        setSelectedOptions(prev => ({
            ...prev,
            [index]: option
        }));
        // setSelectedAnswers(prev => ({
        //     ...prev,
        //     [`question${index + 1}Type`]: questionsData[index].type,
        //     [`question${index + 1}Answer`]: option
        // }));
        debugger;
        const updatedAnswers = (prev) => ({
            ...prev,
            [`question${currentQuestionIndex + 1}Type`]: questionsData[currentQuestionIndex].type,
            [`question${currentQuestionIndex + 1}Answer`]: option == "" ? finalObj[`question${currentQuestionIndex + 1}Answer`] : option
        });
        const updatedFinalObj = updatedAnswers(selectedAnswers); // Pass current selectedAnswers
        finalObj = { ...updatedFinalObj };
        setSelectedAnswers(finalObj);
        if (callApi){
            debugger;
            finalObj[`question${index + 1}Type`] =  questionsData[index].type
            finalObj[`question${index + 1}Answer`] = t('Skip_question')
            validateQuestionsApi(finalObj)
        }
    };

    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, footerMsg, showErrorImg, isBorderNone, btn1Focus, btn2Focus,btn3Exists,btn3Text) => {
        setshowErrorImg(showErrorImg)
        setisBorderNone(isBorderNone)
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setFooterMsg(footerMsg)
        setBtn1Focus(btn1Focus)
        setBtn2Focus(btn2Focus)
        setbtn3Exists(btn3Exists)
        setBtn3Text(btn3Text)
    }

    const navigateToLogin = async () =>{
        // debugger;
        // if (accessTokenToApi == undefined || accessTokenToApi == null) {
        //   return;
        // }
        // global.isLoggedIn = false
        // await logout()
        // logoutManually();
        // const deviceIdKey = 'updatedDeviceId';
        // clearStorageExceptKey(sessionStorage, deviceIdKey);
        // clearStorageExceptKey(localStorage, deviceIdKey);
        // store.dispatch({ type: 'LOGOUT' });
        // const loginPayload = { isLoggedIn: false };
        // dispatch({ type: 'LOG_IN', payload: loginPayload });
        setIsLoading(true)
        setTimeout(() => {
            login('/')
            setIsLoading(false)
            setShowModel(false)
        }, 2000);
    }

    const logoutManually = async () => {
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        var url = END_SESSION(appConfigData.AUTH_URL, appConfigData.CLIENT_ID, accessTokenToApi, appConfigData.POST_LOGOUT_REDIRECT_URI);
        window.location.replace(url);
    }



    const closeModel = () => {
        if(subHeaderMsg == t('Idology_Would_you_like_to_skip') || subHeaderMsg == t('Please_answer_these_additional_questions_to')){
            setIsLoading(true)
            setTimeout(() => {
                setIsLoading(false)
                setShowModel(false)
            }, 2000);
        }
        else{
              navigateToLogin()
        }
    }

    useEffect(() => {
        if (skipQuestionCount >= skipLimit) {
            setButtonDisable(true);
        }
        // setSkipButtonHide(currentQuestionIndex === questionsData.length - 1);

        // Enable or disable the "Next" button based on selection
        setNextBtnDisable(!selectedOptions[currentQuestionIndex]);
    }, [skipQuestionCount, currentQuestionIndex, selectedOptions]);

    const onCancelBtnClick = () => {
        if(subHeaderMsg == t('Idology_Would_you_like_to_skip')){
            setIsLoading(true)
            setTimeout(() => {
                setIsLoading(false)
                setShowModel(false)
            }, 2000);
        }
        else{
              navigateToLogin()
        }
    }

    const onAcptBtnClick = () => {
        // debugger;
        if(subHeaderMsg == t('Idology_Would_you_like_to_skip') ){
            if(currentQuestionIndex === questionsData.length - 1){
                setShowModel(false)
                const updatedAnswers = (prev) => ({
                    ...prev,
                    [`question${currentQuestionIndex + 1}Type`]: questionsData[currentQuestionIndex].type,
                    [`question${currentQuestionIndex + 1}Answer`]: t('Skip_question'),
                });
                const updatedFinalObj = updatedAnswers(selectedAnswers); // Pass current selectedAnswers
                finalObj = { ...updatedFinalObj }; 
                setCurrentQuestionIndex(currentQuestionIndex + 1);
                setSkipQuestionCount(skipQuestionCount + 1);
                validateQuestionsApi(finalObj)
        
            }
            else{
            setShowModel(false)
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setSkipQuestionCount(skipQuestionCount + 1);
             const updatedAnswers = (prev) => ({
                    ...prev,
                    [`question${currentQuestionIndex + 1}Type`]: questionsData[currentQuestionIndex].type,
                    [`question${currentQuestionIndex + 1}Answer`]: t('Skip_question'),
                });
                const updatedFinalObj = updatedAnswers(selectedAnswers); // Pass current selectedAnswers
              finalObj = { ...updatedFinalObj }; 
             setSelectedAnswers(finalObj);
            setLocalErrorMessage("");
        }
        }
        else if(subHeaderMsg == t('Idology_verifying_your_documentation_and_will') || subHeaderMsg == t('Idology_Your_Kudzu_account_is_approved')){
              navigateToLogin()
        }
        else if(subHeaderMsg == t('Please_answer_these_additional_questions_to')){
            setIsLoading(true)
            setTimeout(() => {
                setIsLoading(false)
                setShowModel(false)
            }, 2000);
        }
    }


    const handleSkip = () => {
        if (buttonDisable) {
            return;
        }
        showAlertModal(true, '',skipQuestionMessage, t('Idology_Would_you_like_to_skip'), true, true, t('Yes_Skip_this_question'), t('no'), true, require('../../../assets/images/transfer-error.png'), '', false, false, true, false,false,'')
    };

    const fetchStatusCheck = async () => {
        try {
            const deviceId = await retrieveData('updatedDeviceId');
             if(userId){
                var headers = await GetApiHeadersWithOutBearer(deviceId);
                }
                else{
                var headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);  
                }
            // const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
            const URL = IDOLOGY_ACCOUNT_STATUS_CHECK(userId, "0");
            const response = await GetRequest(URL, headers);
            const responseObj = JSON.parse(response);
            return responseObj;
        } catch (error) {
            console.error("Error fetching status:", error);
            return null;
        }
    };


        const checkStatus = async (initialdelay,secondaryDelay,maxAttempts) => {
            await delay(initialdelay);
            let attemptCount = 0;
            while (attemptCount < maxAttempts) {
                const response = await fetchStatusCheck();
                if (response.ResponseCode === STATUS_SUCCESS_CODE) {
                    setIsLoading(false);
                    if(response.Response.isSuccess && response.response?.enrollStatus == 'APP'){
                        showAlertModal(true, t("success"), t("Idology_Your_Kudzu_account_has_been_created"), t('Idology_Your_Kudzu_account_is_approved'), true, false, t('login'), '', true, require('../../../assets/kudzu-plus-images/illo-complete-dark.png'), '', false, false, true, false,false,'')
                    }
                    else{
                        const enrollStatus = response.Response?.enrollStatus;
                        if (enrollStatus !== ENROLL_STATUS_APP) {
                            console.log("Status is pending. Retrying in 15 seconds...");
                            attemptCount++;
                            await delay(secondaryDelay);
                        } else {
                            console.error("Unexpected status:", response.Status);
                            setIsLoading(false);
                            break;
                        }
                    }
                }
                else {
                    setIsLoading(false);
                    var arrMessages = response.Messages;
                    var message = arrMessages[0];
                    var displayText = message.DisplayText;
                    showAlertModal(true, t("kudzu"), '', displayText, true, false, t("login"), '', true, require('../../../assets/images/warning.png'), false, false)
                    break;
                }
                if (attemptCount >= maxAttempts) {
                    console.log("Maximum attempts reached. Stopping polling.");
                    setIsLoading(false);
                    showAlertModal(true,t("thanks"),t("Idology_application_is_under_review"),
                        t("Idology_verifying_your_documentation_and_will"),false,false,t("login"),
                        "",false,require("../../../assets/images/illo-pending.png"),
                        <span className='font-hanken-grotesk lg:w-[380px] block text-[var(--modal-text-heading-clr)] '>
                            {t("For_further_assistance")}&nbsp;
                            <span onClick={() => { window.open(CONTACT_US_URL, "_blank"); }} className=' text-[var(--modal-text-highlight)]  font-bold cursor-pointer'>{t("support_mail")}</span>&nbsp;
                        </span>,false,false,true,false,false,"");
                }
            }
        };

    // useEffect(() => {
    //     if (!scanUrl) return;
      
    // }, [userId, accessTokenToApi, scanUrl]);


    useEffect(() => {
        if(scanUrl){
            setIsLoading(true)
        }
    }, [scanUrl])
   


    const handleIframeLoad = () => {
           setIsLoading(false)
            try {
                if (!scanUrl) return;
                const currentUrl = iframeRef.current.contentWindow.location.href;
                console.log("Current iframe URL:", currentUrl);
                if (currentUrl.includes("/idology/success") || currentUrl.includes("/idology/failure")){
                  setIsLoading(true);
                  checkStatus(5000,5000,3);
                }
              } catch (error) {
                if (!scanUrl) return;
                 checkStatus(INITIAL_DELAY,POLLING_INTERVAL,MAX_ATTEMPTS);
                 console.error("Cannot access iframe URL due to cross-origin restrictions", error);
             }
    };


    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         try {
    //             const currentUrl = iframeRef.current.contentWindow.location.href;
    //             if (currentUrl !== trackedUrl) {
    //                 setTrackedUrl(currentUrl);
    //                 if (currentUrl.includes("/idology/success") || currentUrl.includes("/idology/failure")){
    //                   setIsLoading(true);
    //                   checkStatus(5000,5000,3);
    //                   clearInterval(interval); 
    //                 }
    //             }
    //         } catch (error) {
    //             if (!scanUrl) return;
    //              checkStatus(INITIAL_DELAY,POLLING_INTERVAL,MAX_ATTEMPTS);
    //              console.error("Cannot access iframe URL due to cross-origin restrictions", error);
    //         }
    //     }, 5000); 
    //     return () => clearInterval(interval); 
    // }, [trackedUrl]);

 
    


    return (
        <>
            <IdologyLayout>
                <div className='sm:px-[6%] md:py-10 sm:py-12 flex flex-wrap sm:flex-nowrap'>
                    <div className='lg:w-[278px] md:w-[290px] w-[185px] sm:mx-0 ml-[2.5rem]'>

                       {!scanUrl && ( <p className="text-white font-normal
        lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px] 
        sm:leading-[30px] leading-[31px]
         font-serif-pro lg:pb-14 md:pb-[50px] sm:pb-[2.6rem] pb-[2.6rem] mb-10">
                            <span className='text-[#94C3E8]'>Okay!</span> We have some security questions for you.</p> )}
                    </div>
                    <div className='md:w-[150px] sm:w-[70px] w-[0px]'></div>
                    <div className="flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] animate__animated animate__fadeInRight">
                        {!scanUrl &&
                            <DynamicCard
                                header={false}
                                CardRadius={true}
                                cardWidth={width.allpolicies}
                                HeaderRadius={true}
                                isWhiteForSignup={appThemeData.isWhiteBgForCard}
                                isDarkForKudzu={appThemeData.isDarkBgForCard}
                                HeaderContent={false}>
                                <div className="md:py-20 sm:py-12 py-12 sm:mx-0 mx-4">
                                    <div className="flex-col justify-center sm:mx-0 mx-4">
                                        <div className="w-full flex justify-center">
                                            <div className="sm:w-[70%] md:w-[70%] w-full font-hanken-grotesk font-[500]">
                                                <div className="font-serif-pro lg:text-[32px] md:text-[30px] sm:text-[22px] text-[25px] font-normal lg:w-[392px] md:w-[368px] sm:w-[270px] text-[var(--idology-text-color)] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px]">
                                                    <span className="text-[var(--idology-securityQuestion-text-color)]">
                                                        Security Question {currentQuestionIndex + 1}:
                                                    </span>
                                                    {questionsData[currentQuestionIndex]?.prompt}
                                                </div>

                                                <div className="flex flex-col gap-4 w-full justify-between mt-5">
                                                    {questionsData[currentQuestionIndex]?.answers?.filter(answer => answer !== t('Skip_question')).map((option, index) => (
                                                        <div key={option.id} className="flex flex-col mb-5 sm:mb-0 gap-4 w-full mt-3">
                                                            <div className="flex flex-row justify-start items-start gap-1 sm:gap-4" onClick={() => handleSelectOption(option,currentQuestionIndex, false)}>

                                                                <button>
                                                                    <img
                                                                        src={selectedOptions[currentQuestionIndex] === option ? RadialFill : RadialNull}
                                                                        alt="Radio"
                                                                        className="cursor-pointer h-[20px] w-[20px] sm:h-[18px] sm:w-[18px] md:h-[20px] md:w-[20px]"
                                                                    />
                                                                </button>


                                                                <div className="flex flex-col">
                                                                    <p className="font-hanken-grotesk font-[500]  lg:text-[16px] md:text-[16px] sm:text-[13px] text-[14px] leading-[20px] sm:leading-[20px] md:leading-[24px] text-[var(--idology-text-color)]">
                                                                        {capitalizeFirstLetter(option)}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>

                                                {localErrorMessage != "" && <div className="flex sm:mx-0 flex-row gap-4 justify-start mt-8 mb-28">
                                                    <img src={Oops} alt="oops" className="md:w-[20px] md:h-[20px] sm:w-[14px]
                sm:h-[14px] w-[15px] h-[15px] mt-1 sm:mt-0 md:mt-1  self-start" />
                                                    <p className={`font-hanken-grotesk font-[500] text-[16px]  
            leading-[24px] md:text-[18px] md:leading-[28px] sm:text-[12px] 
            sm:leading-[18px] text-white `}>
                                                        <span className="text-[#30BC89] font-[600]
                lg:font-[600]"> Oops! </span>{localErrorMessage}</p>
                                                </div>}

                                                <div className="lg:pt-20 md:pt-18 sm:pt-10 py-16 w-full">
                                                    <div className={`flex ${skipButtonHide ?'justify-end' :'justify-between'} items-center w-full`}>
                                                        <button
                                                            type="button"
                                                            onClick={handleSkip}
                                                            disabled={buttonDisable}
                                                            className={`font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] cursor-pointer flex items-center text-[var(--skip-text-color)] ${buttonDisable ? "opacity-50 cursor-not-allowed" : ""}`}>
                                                            {t('Skip Question')}
                                                        </button>

                                                        <button
                                                            type="button"
                                                            onClick={handleNextQuestion}
                                                            disabled={nextBtnDisable}
                                                            className={`font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] cursor-pointer flex items-center  ${nextBtnDisable ? "text-[var(--skip-text-color)] opacity-50 cursor-not-allowed" : "text-[var(--next-active-text-color)]"} `}>
                                                            {t('next')}
                                                            <img src={nextBtnDisable ? appThemeData.SignupNextArrow : appThemeData.arrowWhiteTwofac} className="ml-1" alt="Arrow" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </DynamicCard>}

                        {scanUrl &&
                            <iframe
                                ref={iframeRef}
                                src={scanUrl}
                                title="secureURL" className="w-full min-h-[700px]"
                                onLoad={handleIframeLoad}
                            />}
                    </div>
                </div>


            </IdologyLayout>
            {showModel &&
                <CustomAlertModel
                    isOpen={showModel}
                    onClose={closeModel}
                    // modalBg={'bg-[#262B3A]'}
                    // overLayBg={'bg-[#324261]'}
                    closeIconChange={true}
                    image={modelImage}
                    // imageMargin={}
                    // highlightMsg={highlightMsg && <span className={HighlightMsgStyles}>{highlightMsg}</span>}
                    // HeaderMsg={<span className={HeaderMsgStyles}>{headerMsg}</span>}
                    HeaderMsg={<p className='lg:w-[400px]'><span className={HighlightMsgStyles}>{highlightMsg}</span> <span className={HeaderMsgStyles}>{headerMsg}</span></p>}
                    subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                    btn1Exists={btn1Exists}
                    centerImage={true}
                    btn2Exists={btn2Exists}
                    btn3Exists={btn3Exists}
                    btn1Text={btn1Text}
                    btn2Text={btn2Text}
                    btn3Text={btn3Text}
                    btn1TypeAcpt={btn1TypeAcpt}
                    verificationFailure={() => { }}
                    footerMsg={footerMsg}
                    onAcptBtnClick={onAcptBtnClick}
                    subFooter={<p className={SubHeaderMsgStyles}>{subFooter}</p>}
                    onCancelBtnClick={onCancelBtnClick}
                    showErrorImg={showErrorImg}
                    isBorderNone={isBorderNone}
                    btn1Focus={btn1Focus}
                    btn2Focus={btn2Focus}
                />
            }
            {isLoading && <Loader />}
        </>
    );
};

// export default withOidcSecure(SecurityQuestion);
export default SecurityQuestion;
